import {type} from 'arktype'

import type {SupportedCountries} from '@/lib/locale/country'

export const FOOD_SUPPORTED_COUNTRIES = ['US'] as const satisfies SupportedCountries[]

export const FoodSupportedCountries = type.enumerated(...FOOD_SUPPORTED_COUNTRIES)
export type FoodSupportedCountries = typeof FoodSupportedCountries.infer

export function isFoodSupportedCountry(country: unknown): country is FoodSupportedCountries {
  if (typeof country !== 'string') return false
  return FOOD_SUPPORTED_COUNTRIES.includes(country)
}

export const TIPS_PRESET: Record<FoodSupportedCountries, number[]> = {
  US: [1, 2, 3],
}

export const TIPS_NUMBER_FORMAT_OPTIONS: Record<FoodSupportedCountries, Intl.NumberFormatOptions> =
  {
    US: {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'symbol',
      currencySign: 'accounting',
      signDisplay: 'exceptZero',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
  }
